import getItem from "./getItem";
import setItem from "./setItem";

const globalStorage = {
  getItem,
  setItem,
};

export default globalStorage;
